/**
 * Who must take part in a booking, judged by the two flags separately
 * (docs/prd-homepage-redesign.md §4.2, AC6). participation sets the flags:
 * parent-child = child + adult, kid-only = child (adult optional), adult-only = adult.
 * Shared by checkout (frontend) and every backend booking entry point.
 */
export type ParticipantViolation =
  | 'CHILDREN_NOT_ALLOWED'
  | 'ADULT_REQUIRED'
  | 'CHILD_REQUIRED'
  | 'GUARDIAN_REQUIRED';

export function participantViolation(
  activity: { childRequired: boolean; adultRequired: boolean },
  kids: number,
  adults: number
): ParticipantViolation | null {
  if (!activity.childRequired) {
    if (kids > 0) return 'CHILDREN_NOT_ALLOWED';
    if (adults < 1) return 'ADULT_REQUIRED';
    return null;
  }
  if (kids < 1) return 'CHILD_REQUIRED';
  if (activity.adultRequired && adults < 1) return 'GUARDIAN_REQUIRED';
  return null;
}
